
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M3.30311 15.8333H5.95463V9.39388L2.16675 6.55298V14.6969C2.16675 15.3257 2.67622 15.8333 3.30311 15.8333Z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M15.0455 15.8333H17.697C18.3258 15.8333 18.8334 15.3238 18.8334 14.6969V6.55298L15.0455 9.39388","fill":"#34A853"}}),_c('path',{attrs:{"d":"M15.0455 4.46991V9.39415L18.8334 6.55324V5.03809C18.8334 3.63279 17.2292 2.83165 16.1061 3.67446","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M5.95468 9.39373V4.46948L10.5001 7.87857L15.0456 4.46948V9.39373L10.5001 12.8028","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M2.16675 5.03736V6.55251L5.95463 9.39342V4.46918L4.89402 3.67372C3.76902 2.83092 2.16675 3.63206 2.16675 5.03736Z","fill":"#C5221F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"16.6667","height":"12.5","fill":"white","transform":"translate(2.16675 3.33325)"}})])])])
          )
        }
      }
    